import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

export class QueryAllowGainCouponList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.COUPON
		this.url = '/querycoupon/queryAllowGainCouponList'
		this.desc = '查询优惠券列表'
	}
}

export class GetUserCouponDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.COUPON
		this.url = '/usercoupon/getUserCouponDetail'
		this.desc = '查询用户优惠券详情'
	}
}

export class BoundUserCoupon extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.COUPON
		this.url = '/usercoupon/boundUserCoupon'
		this.desc = '用户领取优惠劵'
	}
}

export class GetCouponDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.COUPON
		this.url = '/querycoupon/getCouponDetail'
		this.desc = '获取优惠详细信息'
	}
}

export class GetCouponDetailById extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.COUPON
		this.url = '/querycoupon/getCouponDetailById'
		this.desc = '根据id获取优惠劵详情信息'
	}
}

export class QueryProductsByCouponId extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.COUPON
		this.url = '/couponandproduct/queryProductsByCouponId'
		this.desc = '获取优惠劵关联产品ID信息'
	}
}
